import { AboutList } from "./AboutList";
import { AboutEdit } from "./AboutEdit";

export { AboutList, AboutEdit };



// WEBPACK FOOTER //
// ./src/components/about/index.js